import { GetObjectCommand, S3Client } from '@aws-sdk/client-s3';
import { saveAs } from 'file-saver';
import { FiDownload } from 'react-icons/fi';
import { useState } from 'react';
import './Dialysis.css';
const DownloadPdfButton = ({ fileName, type }) => {
    const [isLoading, setIsLoading] = useState(false);
    const path = fileName.replace(/\.pdf$/, '');
    // Initialize Wasabi S3 client
    const s3Client = new S3Client({
        region: 'ap-southeast-1',
        credentials: {
            accessKeyId: "Y0WWU13PSR9JMDUASN8V",
            secretAccessKey: "DF7tATk9SPB0aGkf8tzXkYcfHaBhl2BQzp3hRcm1",
        },
        endpoint: "https://s3.ap-southeast-1.wasabisys.com",
        forcePathStyle: true
    });

    const handleDownload = async () => {
        setIsLoading(true);

        try {
            // Construct the file path (same as your upload path)
            const filePath = `Peace Village/patient/${path}/${type}/${fileName}`;

            // Create GetObject command
            const command = new GetObjectCommand({
                Bucket: "pvdev",
                Key: filePath,
                ResponseContentDisposition: `attachment; filename="${fileName}"`
            });

            // Fetch the file from Wasabi
            const response = await s3Client.send(command);

            // Convert the stream to a blob
            const chunks = [];
            for await (const chunk of response.Body) {
                chunks.push(chunk);
            }
            const blob = new Blob(chunks, { type: 'application/pdf' });

            // Trigger download
            saveAs(blob, fileName);

        } catch (error) {
            console.error('Download failed:', error);
            alert(`Download failed: ${error.message}`);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <button
            onClick={handleDownload}
            disabled={isLoading}
            className="styles-downloadButton"
            title={`Download ${fileName}`}
        >
            {isLoading ? (
                <span className="animate-pulse"><svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24"><path fill="currentColor" d="M12 2A10 10 0 1 0 22 12A10 10 0 0 0 12 2Zm0 18a8 8 0 1 1 8-8A8 8 0 0 1 12 20Z" opacity={0.5}></path><path fill="currentColor" d="M20 12h2A10 10 0 0 0 12 2V4A8 8 0 0 1 20 12Z"><animateTransform attributeName="transform" dur="1s" from="0 12 12" repeatCount="indefinite" to="360 12 12" type="rotate"></animateTransform></path></svg></span>
            ) : (
                <FiDownload classNam="styles-downloadIcon" size={20} />
            )}
        </button>
    );
};

export default DownloadPdfButton;